import { Button } from "@mui/material";
import React, { useEffect, useCallback, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import SendIcon from "@mui/icons-material/Send";
import CancelIcon from "@mui/icons-material/Cancel";
// import { setMessageStorage } from "../../Model/LocalStorage";
import PersonIcon from '@mui/icons-material/Person';
function Chat({ socket, username, room, handleClose, sender }) {
  const [currentMessage, setCurrentMessage] = useState("");
  const [messageList, setMessageList] = useState([]);

  const sendMessage = async () => {
    if (currentMessage !== "") {
      const messageData = {
        room: room,
        author: username,
        sender: sender,
        message: currentMessage,
        time:formatAMPM(new Date),
      };
      await socket.emit("send_message", messageData);
      setMessageList((list) => [...list, messageData]);
      setCurrentMessage("");
    }
  };

//   const Reconnect = () => {
//     socket.on("connect", (err) => {
//       console.log(err);
//       // alert("connected Successfully")
//     });
//   });

const [colorRandom, setCOlor] = useState(Math.floor(Math.random()*16777215).toString(16));

function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  // socket.on('receivePrivateMessage', (data) => {
  //   if (data.roomId === roomId) {
  //     setMessages((prev) => [...prev, data.message]);
  // }



  useEffect(() => {
    socket.on("receive_message", (data) => {


      setMessageList((list) => [...list, data]);
    });
     return () => {
        socket.off('receive_message');
    };

  }, [socket, username, room, handleClose, sender]);

  const handleExit = () => {
    handleClose();
  };
//   style={{backgroundColor:  username === "deleonfsad@gmail.com" ? '#'+colorRandom:'rgb(24 118 210)'}}

  return (
    <div className="chat-window" >
      <div className="chat-header" >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p>
           <PersonIcon/> {username === "deleonfsad@gmail.com" ? "Support Chat" : username}
          </p>
          <p onClick={handleExit}>
            <CancelIcon />
          </p>
        </div>
      </div>
      <div className="chat-body">
        <ScrollToBottom className="message-container">
          { messageList?.filter((x) => x.sender === sender).map((messageContent) => {
                return (
                  <div
                    className="message"
                    id={room !== messageContent.room ? "you" : "other"}
                  >
                    <div>
                      <div className="message-content" >
                        <p  className="fontFam">{messageContent.message}</p>
                      </div>
                      <div className="message-meta">
                        <p id="time">{messageContent.time}</p>
                        {/* <p id="author">{messageContent.author}</p> */}
                      </div>
                    </div>
                  </div>
                );
              })
          }
        </ScrollToBottom>
      </div>
      <div className="chat-footer">
        <input
        style={{background: "#d9d9d9",}}
          type="text"
          value={currentMessage}
          placeholder="typ e yourmessage here..."
          onChange={(event) => {
            setCurrentMessage(event.target.value);
          }}
          onKeyPress={(event) => {
            event.key === "Enter" && sendMessage();
          }}
        />

        <div
          style={{
            height: 50,
            width: 60,
            background: "#d9d9d9",
            textAlign: "center",
          }}
          onClick={sendMessage}
        >
          <SendIcon style={{ marginTop: 10,color:'rgb(24 118 210)' }} />
        </div>
      </div>
    </div>
  );
}

export default Chat;
